import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/jackpot_winner`;

class JackpotWinnerServices {
  async getSessionList(activeGame, date_filter) {
    try {
      const action =
        API_ROUTE +
        `/get-session-list?game=${activeGame}&date_filter=${date_filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getSessionList:", error);
      throw error;
    }
  }

  async getJackpotSessionList(filter) {
    try {
      const action =
        API_ROUTE +
        `/get-jackpot-session-list?${filter}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getJackpotSessionList:", error);
      throw error;
    }
  }

  async createJackpotWinner(payload) {
    try {
      const action = API_ROUTE + `/save-jackpot_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in createJackpotWinner:", error);
      throw error;
    }
  }

  async updateJackpotWinner(payload) {
    try {
      const action = API_ROUTE + `/update-jackpot_winner-data`;
      return await requestToken.post(action, payload);
    } catch (error) {
      console.error("Error in updateJackpotWinner:", error);
      throw error;
    }
  }
  async deleteJackpotWinnerSession(session_id) {
    try {
      const action = API_ROUTE + `/delete-jackpot_winner-data?session_id=${session_id}`;
      return await requestToken.del(action);
    } catch (error) {
      console.error("Error in deleteJackpotWinnerSession:", error);
      throw error;
    }
  }


}

export default JackpotWinnerServices;
